import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6032b226"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "recommend" }
const _hoisted_2 = { class: "imgs" }
const _hoisted_3 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: _ctx.webpFilters($setup.item.images.L),
        alt: ""
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("h2", null, _toDisplayString($setup.currencyUnit) + " " + _toDisplayString(parseInt($setup.item.price).thousands()), 1),
    _createElementVNode("p", null, _toDisplayString($setup.item.name), 1)
  ]))
}